var _defs, _path, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRegistrationDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_1",
    "data-name": "Component 2 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 460,
    height: 594,
    viewBox: "0 0 460 594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    d: "M10,0H460a0,0,0,0,1,0,0V594a0,0,0,0,1,0,0H10A10,10,0,0,1,0,584V10A10,10,0,0,1,10,0Z",
    transform: "translate(240 95)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 47"
  }, /*#__PURE__*/React.createElement("image", {
    width: 300,
    height: 47,
    xlinkHref: "data:image/png;base64,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"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    d: "M10,0H460a0,0,0,0,1,0,0V594a0,0,0,0,1,0,0H10A10,10,0,0,1,0,584V10A10,10,0,0,1,10,0Z",
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(-240 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messaging_application",
    "data-name": "Messaging application",
    transform: "translate(-63.5 -37.858)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 198.5,
    cy: 198.5,
    r: 198.5,
    transform: "translate(335 262.863)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_",
    d: "M204.407,142.135c5.637-3.382,11.274-6.2,16.348-10.147,30.44,24.24,48.479,62.572,47.915,100.9a9,9,0,0,1-7.328,8.456,83.224,83.224,0,0,1-46.788-7.328,84.514,84.514,0,0,1-46.224-54.68c3.382-7.892,9.019-15.22,15.22-21.985-.564,23.112,12.965,45.661,33.259,57.5,10.147,5.637,21.421,9.019,32.7,9.019C247.813,191.741,230.338,161.3,204.407,142.135ZM182.423,40.667C200.461,16.427,232.029,2.9,261.906,7.408c3.382,1.127,6.765,4.51,6.765,8.456.564,40.024-19.166,79.483-50.734,103.159-11.274,9.583-25.931,14.656-36.641,24.24-16.348,14.093-28.749,34.386-32.132,55.807-2.819,16.911-1.691,33.823-1.691,50.734,0,4.51-3.946,7.892-8.456,8.456a9.174,9.174,0,0,1-10.147-9.019c-.564-21.985,2.255-45.1-6.2-66.518-.564-12.4,0-24.8,0-37.2,5.637,7.892,11.274,16.348,14.656,25.931a138.318,138.318,0,0,1,27.622-39.46V89.71A87.975,87.975,0,0,1,182.423,40.667ZM7.108,15.3c0-3.946,3.382-7.892,7.328-7.892A86.793,86.793,0,0,1,68.553,18.682c25.931,15.22,42.842,45.1,41.715,75.537v63.136c.564,25.931-12.4,51.861-32.7,67.645a86.057,86.057,0,0,1-56.935,18.039c-3.946,0-9.019,0-11.274-3.382-2.819-5.073-1.691-10.147-1.691-14.093C9.363,189.487,27.4,155.1,55.024,131.988c5.637,3.382,11.274,7.328,16.911,10.147-26.494,18.6-43.406,49.607-45.661,81.738,27.622,0,54.116-18.6,62.572-45.1,4.51-11.838,3.382-24.8,3.946-37.2C84.9,134.243,74.754,130.3,65.734,124.1,29.657,100.42,6.545,58.142,7.108,15.3ZM132.252,120.714c4.51-3.946,11.838-1.691,14.093,3.946,2.819,5.637-2.819,13.529-9.019,12.4C129.434,137.061,125.488,125.224,132.252,120.714Zm-.564-43.406c9.019-4.51,20.857,2.819,21.421,12.965.564,7.892-6.2,15.784-14.093,16.348-8.456,1.127-15.784-6.2-16.348-14.657C122.105,85.764,126.051,80.127,131.689,77.308Zm2.819-31c6.765-3.382,15.22,5.073,11.838,11.838-2.255,6.765-11.838,7.892-15.784,2.255A9.424,9.424,0,0,1,134.507,46.3ZM188.06,67.161c-6.765,16.348-3.382,34.386-4.51,51.3,11.838-6.765,23.112-13.529,32.7-23.112a114.045,114.045,0,0,0,33.823-71.028C223.01,24.319,197.643,42.358,188.06,67.161ZM26.274,24.883A116.629,116.629,0,0,0,48.259,83.509C59.533,99.293,75.881,110,92.229,119.023V90.837a64.012,64.012,0,0,0-18.6-45.1A64.557,64.557,0,0,0,26.274,24.883Z",
    transform: "translate(401.109 314.124)",
    fill: "#cecece",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(470.047 335.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(25.918 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1331.008,448.2v351H1144.954v-351Z",
    transform: "translate(-1130.313 -423.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1269.989,731.787H1098.914a21.512,21.512,0,0,1-21.488-21.488V356.536a21.512,21.512,0,0,1,21.488-21.488h171.075a21.512,21.512,0,0,1,21.488,21.488V710.3A21.512,21.512,0,0,1,1269.989,731.787ZM1098.914,336a20.555,20.555,0,0,0-20.532,20.532V710.3a20.555,20.555,0,0,0,20.532,20.532h171.075a20.555,20.555,0,0,0,20.532-20.532V356.536A20.555,20.555,0,0,0,1269.989,336Z",
    transform: "translate(-1077.426 -335.048)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1473.054,382.039a4.628,4.628,0,1,1,4.627-4.628A4.633,4.633,0,0,1,1473.054,382.039Zm0-8.3a3.672,3.672,0,1,0,3.672,3.672A3.676,3.676,0,0,0,1473.054,373.74Z",
    transform: "translate(-1383.654 -364.603)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1561.56,387.318h-32.692v-4.906h32.692Zm-31.736-.956h30.78v-2.994h-30.78Z",
    transform: "translate(-1430.991 -372.143)",
    fill: "#363e44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(7.27 -105.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(59 253.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M960.089,600.058h104.893l37.5-1.039L1082.565,610v33.692H960.089Z",
    transform: "translate(-959.611 -598.542)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1080.839,642.135H958.363a.478.478,0,0,1-.478-.478v-43.63a.478.478,0,0,1,.478-.478h104.893l37.488-.734a.478.478,0,0,1,.24.9l-19.667,10.841v33.1A.478.478,0,0,1,1080.839,642.135Zm-122-.956h121.519V608.27a.478.478,0,0,1,.247-.419l18.219-10.042-35.562.7H958.841Z",
    transform: "translate(-957.885 -596.815)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(10.135 9.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1105.119,724.253h-97.16a.478.478,0,1,1,0-.956h97.16a.478.478,0,0,1,0,.956Z",
    transform: "translate(-1006.863 -705.204)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1107.178,768.175h-99.219a.478.478,0,1,1,0-.956h99.219a.478.478,0,0,1,0,.956Z",
    transform: "translate(-1006.863 -739.603)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1102.269,640.8h-97.16a.478.478,0,1,1,0-.956h97.16a.478.478,0,0,1,0,.956Z",
    transform: "translate(-1004.631 -639.846)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1104.328,684.724h-99.219a.478.478,0,1,1,0-.956h99.219a.478.478,0,1,1,0,.956Z",
    transform: "translate(-1004.631 -674.245)",
    fill: "#554494"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(-3335.934 -1824.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(3680.072 2239.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(31.721 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M3837.667,2262.9c-4.541-2.791-5.725-9.4-3.356-14.175s7.5-7.729,12.751-8.654a24.533,24.533,0,0,1,21.236,6.694c2.948,2.948,5.357,6.815,9.314,8.127,3.479,1.154,7.292.011,10.933.428,4.881.56,9.107,3.962,11.667,8.155s3.662,9.111,4.311,13.98c.6,4.469,1.017,9.378,4.171,12.6,3.076,3.142,7.87,3.747,11.67,5.959,7.149,4.161,9.6,14.692,5.024,21.583-1.459,2.2-3.571,4.223-3.7,6.857-.123,2.4,1.461,4.521,2.223,6.807,1.958,5.882-2.777,12.974-8.96,13.42-3.122.225-6.487-.944-9.268.494-2.762,1.428-3.748,4.8-5.49,7.374a13.382,13.382,0,0,1-16.251,4.452c-2.315-1.094-4.512-2.922-7.064-2.713s-4.521,2.415-7.021,2.937c-3.274.683-6.427-1.69-8.419-4.376s-3.4-5.865-5.93-8.051c-3.314-2.862-7.921-3.513-12.082-4.879a33.874,33.874,0,0,1-19.821-47.168",
    transform: "translate(-3820.153 -2239.726)",
    fill: "#1a2e35"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(95.98 78.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M4021.711,2486.782a9.2,9.2,0,0,1,3.617-2.456l-.279-.013a5.407,5.407,0,0,1,.78-.144,3.632,3.632,0,0,1,2.859.311l-.027,0a6.759,6.759,0,0,1,3.742,3.163,7.994,7.994,0,0,1-.821,8.252,6.112,6.112,0,0,1-11.244-1.935A7.589,7.589,0,0,1,4021.711,2486.782Z",
    transform: "translate(-4019.986 -2484.018)",
    fill: "#375a64"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(33.072 24.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M3830.433,2422.017l-6.066-87.7a7.453,7.453,0,0,1,6.337-7.838l39.079-11.687c12.6-1.883,21.679,13.335,23.026,26,1.5,14.07,2.769,31.306,1.55,41.9-2.45,21.311-19.83,24.787-19.83,24.787-.008-.071.188,21.663.429,29.358l5.185,23.79Z",
    transform: "translate(-3824.352 -2314.628)",
    fill: "#e2a18d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(22.654 84.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M3922.2,2585.368s-12.927,1.448-27.4-6.425c0,0,6.36,15.661,27.46,12.768Z",
    transform: "translate(-3894.801 -2578.943)",
    fill: "#d19484"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(49.934 12.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M3942.474,2309.525a14.546,14.546,0,0,0-5.7-7.932c-1.54-.972-3.321-1.552-4.754-2.674-3.1-2.425-3.868-6.715-5.809-10.136a15.993,15.993,0,0,0-12.3-7.9c-4.2-.368-8.507.955-12.613-.017-3.035-.718-5.7-2.642-8.776-3.179-5.981-1.046-11.464,3.315-15.727,7.641.047,4.27,3.49,7.076,6.805,9.768a14.808,14.808,0,0,0,12.036,2.989c3.25-.643,6.8-2.343,9.644-.648,2.994,1.783,3.182,6.253,5.846,8.5,3.809,3.209,9.743.059,14.537,1.4,3.7,1.039,6.057,4.529,8.55,7.458s6.2,5.693,9.872,4.545A43.293,43.293,0,0,0,3942.474,2309.525Z",
    transform: "translate(-3876.791 -2277.524)",
    fill: "#1a2e35"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(0 14.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M3792.067,2296.221c-2.685-.726-8.182-2.377-9.651-4.676-3.188-4.992-8.73-8.351-14.337-7.962a13.492,13.492,0,0,0-11.991,10.841,19.4,19.4,0,0,0-16.515,10.977,20.3,20.3,0,0,0-1.022,2.5,14.757,14.757,0,0,0-.806,12.4c.961,2.4,2.576,5.066,1.367,7.352-1.231,2.328-4.426,2.447-6.9,3.341a9.8,9.8,0,0,0-6.013,11.035c.369,1.6,1.161,3.2.85,4.809-.324,1.68-1.741,2.884-2.822,4.209a12.2,12.2,0,0,0,7.442,19.746c1.907.318,3.968.208,5.63,1.2,1.9,1.134,2.765,3.394,4.123,5.146a10.521,10.521,0,0,0,11.452,3.4,9.575,9.575,0,0,0,2.274-1.186c1.3,1.749,3.317,2.916,6.736,2.866l-1.438-44.639a3.7,3.7,0,0,0,2.738,2.081c7.189,1.517,8.021-13.267,6.364-17.246a41.673,41.673,0,0,0,7.08-7.666c1.936-2.954,3.561-10.953,3.086-14.537C3782.3,2300.334,3793.247,2296.54,3792.067,2296.221Z",
    transform: "translate(-3721.505 -2283.552)",
    fill: "#1a2e35"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(27.687 67.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M3820.886,2453.646c-.293-4.535-5.86-5.424-9.761-3.093-2.141,1.28-3.756,3.814-3.487,8.629.717,12.841,13.461,9.472,13.463,9.1C3821.1,2468.057,3821.23,2458.956,3820.886,2453.646Z",
    transform: "translate(-3807.608 -2449.307)",
    fill: "#e2a18d"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(30.972 71.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M3823.837,2472.722c-.059-.038-.215.169-.583.364a2.235,2.235,0,0,1-1.67.128c-1.385-.422-2.647-2.512-2.839-4.823a7.405,7.405,0,0,1,.448-3.237,2.585,2.585,0,0,1,1.586-1.811,1.141,1.141,0,0,1,1.354.54c.192.349.125.61.194.629.038.03.264-.231.131-.756a1.429,1.429,0,0,0-.55-.776,1.691,1.691,0,0,0-1.255-.258,3.149,3.149,0,0,0-2.226,2.121,7.6,7.6,0,0,0-.576,3.623c.227,2.583,1.687,4.93,3.573,5.363a2.4,2.4,0,0,0,2.026-.454C3823.831,2473.034,3823.883,2472.743,3823.837,2472.722Z",
    transform: "translate(-3817.824 -2462.695)",
    fill: "#d19484"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(22.978 23.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M3822.806,2312.955a7.671,7.671,0,0,0-2.532,2.184c-1.247,1.769-1.677,5.131-.816,8.9l.075.323-.316.083a12.427,12.427,0,0,0-8.171,7.414,9.682,9.682,0,0,0-.619,3.144,18.873,18.873,0,0,0,.451,3.389,25.477,25.477,0,0,1,.543,3.649,6.045,6.045,0,0,1-.962,3.806c-1.563,2.455-4.114,3.689-6.3,4.882a21.621,21.621,0,0,0-5.909,3.995,16.057,16.057,0,0,0-4.641,10.836,16.763,16.763,0,0,0,1.809,7.915c.879,1.742,1.608,2.568,1.536,2.622-.024.02-.214-.176-.558-.569a13.682,13.682,0,0,1-1.29-1.885,16.318,16.318,0,0,1-2.139-8.09,16.526,16.526,0,0,1,4.685-11.413,22.122,22.122,0,0,1,6.089-4.2c2.19-1.193,4.593-2.414,5.953-4.58,1.395-1.971.721-4.509.313-6.8a19.467,19.467,0,0,1-.448-3.56,10.426,10.426,0,0,1,.7-3.44,13.021,13.021,0,0,1,8.792-7.765l-.242.406c-.818-3.95-.267-7.433,1.161-9.276a5.4,5.4,0,0,1,1.986-1.668A3.106,3.106,0,0,1,3822.806,2312.955Z",
    transform: "translate(-3792.963 -2312.949)",
    fill: "#375a64"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(30.531 83.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M3818.177,2503.221a9.185,9.185,0,0,1,3.617-2.456l-.279-.013a5.318,5.318,0,0,1,.78-.144,3.631,3.631,0,0,1,2.859.311h-.027a6.757,6.757,0,0,1,3.741,3.162,8,8,0,0,1-.821,8.252,6.111,6.111,0,0,1-11.243-1.935A7.584,7.584,0,0,1,3818.177,2503.221Z",
    transform: "translate(-3816.452 -2500.456)",
    fill: "#375a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(3898.543 2388.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M4400.916,2736.958l8.754-3.356s2.387-7.636,3.976-9.876,10.04-9.1,10.536-9.292,6.048-12.638,8.578-12.233,4.275,2.182,3.567,5.562-6.313,10.119-4.761,11.24a11.343,11.343,0,0,0,4.082,1.526s.688-3.882,2.818-5.138,4.558.83,4.558.83l.065,1.674,2.1-1.925s2.213-7.8,5.566-7.759a13.644,13.644,0,0,1,3.31-4.449,2.887,2.887,0,0,1,4.447,1.3h0l-6.021,17.666-16.559,18.242s-7.763,2.982-9.739,3.9-10.956,7.129-14.927,8.457-8.586,3.35-8.586,3.35Z",
    transform: "translate(-4400.916 -2702.19)",
    fill: "#e2a18d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(7.254 29.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M4439.445,2792.716a10.1,10.1,0,0,0-3.144-.322,14.539,14.539,0,0,0-7.5,1.647,9.092,9.092,0,0,0-3.105,2.992,14.254,14.254,0,0,0-1.482,3.143,9.423,9.423,0,0,0-.721,3.079,15.406,15.406,0,0,0,1.281-2.862,11.211,11.211,0,0,1,4.454-5.618,16.1,16.1,0,0,1,7.084-1.78A13.857,13.857,0,0,0,4439.445,2792.716Z",
    transform: "translate(-4423.474 -2792.394)",
    fill: "#d19484"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(26.086 15.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M4486.826,2752.318c.13-.186-.773-1.005-2.18-1.423s-2.611-.238-2.605-.011,1.087.436,2.361.824S4486.7,2752.522,4486.826,2752.318Z",
    transform: "translate(-4482.04 -2750.641)",
    fill: "#d19484"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(42.895 5.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M4541.053,2734.967a17.9,17.9,0,0,1,.386-3.832c.345-2.382.884-5.716,1.546-9.541l.249.5c-.583-.268-1.291-.688-1.812-.854a2.32,2.32,0,0,0-1.766.226,5.109,5.109,0,0,0-2.047,2.474,18.432,18.432,0,0,0-1.084,3.055c-.479,2.042-.8,3.939-1.092,5.516a31.436,31.436,0,0,1-1.071,5.106,25.346,25.346,0,0,1,.4-5.209c.21-1.6.456-3.5.9-5.614a17.946,17.946,0,0,1,1.092-3.248,5.915,5.915,0,0,1,2.459-2.933,3.258,3.258,0,0,1,2.471-.289,17.5,17.5,0,0,1,1.968.938l.315.146-.066.352c-.713,3.817-1.37,7.129-1.876,9.481A17.9,17.9,0,0,1,4541.053,2734.967Z",
    transform: "translate(-4534.313 -2720.195)",
    fill: "#d19484"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(27.867 12.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M4487.6,2764.338c-.041-.009-.014-.269.075-.759a10.456,10.456,0,0,1,.713-2.027,25.887,25.887,0,0,1,4.345-6.333l-.094.159c1.146-3.392.1-8.3,3.176-12.686a4.027,4.027,0,0,1,3.19-1.418,5.909,5.909,0,0,1,3.092,1.083l.221.15-.034.274c-.616,4.962-1.186,9.249-1.627,12.289a8,8,0,0,1-1.113,3.459c-.431.735-.741,1.082-.784,1.052a6.343,6.343,0,0,1,.5-1.195,8.672,8.672,0,0,0,.816-3.416c.28-3.059.727-7.346,1.285-12.292l.188.424a5.072,5.072,0,0,0-2.573-.878,3.071,3.071,0,0,0-2.446,1.107,7.285,7.285,0,0,0-1.431,2.97,28.137,28.137,0,0,0-.691,3.245c-.185,1.079-.233,2.074-.359,3.141a18.791,18.791,0,0,1-.646,2.927l-.028.09-.066.07a29.639,29.639,0,0,0-4.509,5.984C4487.905,2763.335,4487.7,2764.363,4487.6,2764.338Z",
    transform: "translate(-4487.577 -2741.266)",
    fill: "#d19484"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(3660.434 2361.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(53.148 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M3825.715,2625.989c.528-.76,4.041-7.546,4.041-7.546l19.927,17.177s19.533,16.36,19.533,15.3l3.118-15.738,3.839-14.318,7.167,10.829s22.517,44.146,22.517,44.675,13.936,46.219,13.936,46.219l-3,18.523-.353,65.624-41.986-1.764-8.291-13.231-14.289-84.147Z",
    transform: "translate(-3825.715 -2618.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(88.549 175.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M3952.778,3163.625h44.731l7.087,30.062h-68.79Z",
    transform: "translate(-3935.806 -3163.625)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(24.232 5.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M3815.673,2793.43c-1.408-21.553-.819-62.213-9.068-83.426s-41.369-73.334-41.369-73.334l-8.13,12.639-21.315,8,28.917,117.218s-11.136,26.224-16.44,41.545c-1.585,4.579-3.724,12.353-6.067,20.108h73.177C3816.023,2819.132,3816.338,2803.611,3815.673,2793.43Z",
    transform: "translate(-3735.79 -2636.67)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(131.292 16.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M4181.676,2707.736l-56.41,31.357-39.093-55.783c-.1-.144-.217-.295-.336-.452-4.447-5.888-8.819-12.369-16.018-13.987l-1.09-.246,2.092,66.773s27.8,30.64,43.381,43.31c4.639,3.772,16.4,1.416,22-1.677,22.451-12.389,60.8-44.158,60.8-44.158Z",
    transform: "translate(-4068.729 -2668.625)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(104.829 3.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M4031.462,2770.4s4.11-31.875,5.458-39.878c7.054-41.892-24.022-88.207-24.022-88.207l-14.207-2.351-12.256-10.122,5.414,15.122s17.8,49.8,21.337,65.712,5.3,64.82,5.854,63.641c.325-.694,2.466,29.529,5.155,57.232h30.155Z",
    transform: "translate(-3986.436 -2629.838)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(117.084 13.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M4054.687,2756.261a5.866,5.866,0,0,1,.009-1.038c.041-.741.094-1.726.161-2.959l.133-2.135q0-1.18,0-2.544c0-1.825.044-3.9-.134-6.2a129.1,129.1,0,0,0-6.978-35.085,121.2,121.2,0,0,0-5.66-13.928l-.007-.015-.005-.011a119.369,119.369,0,0,0-6.533-12.731c-2.157-3.749-4.146-7.014-5.812-9.715l-3.937-6.3-1.048-1.685a3.305,3.305,0,0,1-.333-.6,3.051,3.051,0,0,1,.428.539l1.138,1.627c.98,1.429,2.384,3.53,4.1,6.2s3.751,5.916,5.949,9.653a115.08,115.08,0,0,1,6.656,12.764l-.012-.026a117.622,117.622,0,0,1,5.727,14.007,124.067,124.067,0,0,1,6.813,35.286c.147,2.3.073,4.393.033,6.224q-.032,1.368-.062,2.553-.1,1.164-.193,2.138c-.122,1.231-.218,2.214-.291,2.955A5.748,5.748,0,0,1,4054.687,2756.261Z",
    transform: "translate(-4024.545 -2661.315)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(69.329 26.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M3902.99,2706.626a3.089,3.089,0,0,1-.792-.347l-2.151-1.135-7.586-4.2.445-.224c-.37,3.408-1,7.392-1.624,11.636-.253,1.728-.492,3.413-.687,5.025l-.076.622-.476-.4c-4.058-3.453-7.586-6.491-10.086-8.682q-1.751-1.561-2.917-2.6a.71.71,0,1,1,.152-.179l3.046,2.444c2.577,2.1,6.16,5.073,10.24,8.5l-.551.218c.186-1.624.419-3.315.673-5.047.628-4.252,1.286-8.224,1.712-11.606l.057-.454.388.229,7.463,4.413,2.069,1.279A3.055,3.055,0,0,1,3902.99,2706.626Z",
    transform: "translate(-3876.037 -2700.198)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(96.642 13.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M3972.206,2659.653a8.985,8.985,0,0,1,.062,1.8c-.023,1.288-.053,2.928-.088,4.888-.1,4.127-.3,9.825-.55,16.117-.006.155-.013.309-.018.459l-.044,1.1-.589-.928-7.542-11.888.473-.057-2.065,5.678a12.539,12.539,0,0,1-.862,2.062,12.389,12.389,0,0,1,.581-2.158c.48-1.5,1.1-3.434,1.845-5.753l.168-.525.3.468,7.675,11.8-.633.172c.006-.15.012-.3.019-.458.254-6.292.522-11.988.751-16.109.123-1.956.226-3.593.307-4.879A9.016,9.016,0,0,1,3972.206,2659.653Z",
    transform: "translate(-3960.974 -2659.653)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(0 26.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M3684.665,2700.854a31.948,31.948,0,0,0-4.949,3.807,33.717,33.717,0,0,0-8.62,13.579c-2.012,5.748-4.007,12.821-5.165,17.274l-5.394,81.817a48.132,48.132,0,0,0,3.439,21.294l16.707,41.1H3716.7l-19.443-54.989,6.659-60.662Z",
    transform: "translate(-3660.434 -2700.854)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(46.42 17.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M3804.8,2671.743l7.923,23.765h8.441l-5.478,3.487,43.32,82.793",
    transform: "translate(-3804.8 -2671.743)",
    fill: "#493d84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M3859,2781.787a1.29,1.29,0,0,1-.191-.289l-.5-.88-1.86-3.414-6.726-12.617-21.958-41.748-12.367-23.7-.135-.26.246-.155,5.487-3.472.161.553-8.442-.031h-.2l-.06-.184c-2.369-7.26-4.307-13.2-5.671-17.382-.644-2.029-1.152-3.63-1.517-4.778-.155-.515-.279-.928-.376-1.253a1.92,1.92,0,0,1-.1-.436,1.877,1.877,0,0,1,.18.411l.451,1.229,1.654,4.732,5.894,17.307-.256-.184,8.442-.03,1.031,0-.87.557-5.469,3.5.111-.415,12.418,23.671,21.779,41.842,6.531,12.719,1.745,3.475.438.912A1.279,1.279,0,0,1,3859,2781.787Z",
    transform: "translate(-3804.792 -2671.743)",
    fill: "#554494"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(30.437 38.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(0.005 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M3755.1,2736.877a52.838,52.838,0,0,1,11.689,44.962",
    transform: "translate(-3755.102 -2736.877)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M3766.782,2781.836c-.14-.026.454-2.665.7-6.992a55.026,55.026,0,0,0-.111-7.6,54.587,54.587,0,0,0-4.66-17.923,54.993,54.993,0,0,0-3.6-6.688c-2.325-3.658-4.127-5.673-4.019-5.764a9.857,9.857,0,0,1,1.3,1.377,20.71,20.71,0,0,1,1.4,1.725c.516.7,1.142,1.466,1.72,2.4a49.747,49.747,0,0,1,3.772,6.689,51.785,51.785,0,0,1,4.716,18.138,49.784,49.784,0,0,1-.037,7.679c-.053,1.093-.225,2.07-.336,2.93a20.632,20.632,0,0,1-.386,2.191A9.882,9.882,0,0,1,3766.782,2781.836Z",
    transform: "translate(-3755.088 -2736.873)",
    fill: "#1a2e35"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(3696.998 2451.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M3793.851,3013.109a1.3,1.3,0,0,1-.125-.274l-.318-.821c-.28-.759-.673-1.822-1.173-3.175-1.01-2.8-2.453-6.8-4.233-11.727-3.542-9.958-8.423-23.681-13.838-38.905l-.02-.056.007-.059c.046-.423.1-.881.147-1.34,1.826-16.366,3.479-31.178,4.68-41.941.621-5.337,1.124-9.668,1.477-12.7.183-1.471.326-2.627.428-3.451l.125-.9a1.321,1.321,0,0,1,.06-.3,1.415,1.415,0,0,1-.007.309c-.019.231-.043.529-.073.9-.079.827-.189,1.986-.331,3.462-.313,3.04-.762,7.377-1.313,12.721-1.163,10.767-2.762,25.585-4.53,41.957-.05.459-.1.917-.147,1.34l-.013-.114,13.692,38.957c1.715,4.954,3.1,8.968,4.08,11.781.461,1.367.824,2.44,1.083,3.208.111.346.2.622.27.837A1.373,1.373,0,0,1,3793.851,3013.109Z",
    transform: "translate(-3774.144 -2897.457)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(3801.195 2398.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M4098.179,2734.695a79.94,79.94,0,0,1,5.848,11.123c.839,1.756,1.534,3.773,2.386,5.895.716,2.17,1.575,4.462,2.223,6.952.746,2.463,1.32,5.1,1.94,7.83q.377,2.064.768,4.2c.265,1.42.414,2.881.63,4.348a140.335,140.335,0,0,1,.4,30.317c-.215,1.924-.411,3.669-.584,5.21s-.409,2.842-.562,3.916l-.4,2.469a5.428,5.428,0,0,1-.173.855,5.6,5.6,0,0,1,.07-.871q.111-.918.3-2.48c.121-1.078.338-2.388.474-3.923s.32-3.284.507-5.207a147.715,147.715,0,0,0-.551-30.22c-.215-1.461-.363-2.915-.625-4.33s-.51-2.81-.758-4.18c-.611-2.717-1.172-5.347-1.9-7.8-.632-2.482-1.473-4.769-2.168-6.936-.831-2.119-1.5-4.136-2.318-5.894l-1.1-2.536c-.354-.8-.738-1.526-1.069-2.221-.675-1.384-1.243-2.583-1.783-3.524l-1.181-2.2A5.465,5.465,0,0,1,4098.179,2734.695Z",
    transform: "translate(-4098.178 -2734.695)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(3846.63 2447.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M4241.656,2904.569a9.314,9.314,0,0,1-1.037-2.448,24.505,24.505,0,0,1-.562-12.722,9.264,9.264,0,0,1,.817-2.53,24.793,24.793,0,0,1-.459,2.6,29.349,29.349,0,0,0,.556,12.549A24.521,24.521,0,0,1,4241.656,2904.569Z",
    transform: "translate(-4239.475 -2886.868)",
    fill: "#1a2e35"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_2",
    "data-name": "XMLID_2494_",
    d: "M57.171,40.956a40.378,40.378,0,0,0,4.149-2.575,32.617,32.617,0,0,1,12.16,25.607,2.285,2.285,0,0,1-1.86,2.146,21.12,21.12,0,0,1-11.874-1.86A21.448,21.448,0,0,1,48.015,50.4a20.573,20.573,0,0,1,3.863-5.579,16.876,16.876,0,0,0,8.44,14.592,17.242,17.242,0,0,0,8.3,2.289A28.128,28.128,0,0,0,57.171,40.956Zm-5.579-25.75a21.678,21.678,0,0,1,20.171-8.44,2.463,2.463,0,0,1,1.717,2.146A32.728,32.728,0,0,1,60.6,35.091c-2.861,2.432-6.581,3.719-9.3,6.151a24.264,24.264,0,0,0-8.154,14.163c-.715,4.292-.429,8.583-.429,12.875A2.366,2.366,0,0,1,38,68.137c-.143-5.579.572-11.445-1.574-16.881-.143-3.147,0-6.295,0-9.442A26.982,26.982,0,0,1,40.147,48.4a35.1,35.1,0,0,1,7.01-10.014V27.652A22.326,22.326,0,0,1,51.592,15.206ZM7.1,8.769a2.024,2.024,0,0,1,1.86-2A22.026,22.026,0,0,1,22.694,9.627,21.767,21.767,0,0,1,33.28,28.8V44.819A21.646,21.646,0,0,1,10.534,66.564c-1,0-2.289,0-2.861-.858a6.487,6.487,0,0,1-.429-3.576A33.472,33.472,0,0,1,19.261,38.381c1.431.858,2.861,1.86,4.292,2.575A28.034,28.034,0,0,0,11.965,61.7,16.946,16.946,0,0,0,27.844,50.255c1.144-3,.858-6.295,1-9.442-2-1.86-4.578-2.861-6.867-4.435A33.215,33.215,0,0,1,7.1,8.769ZM38.859,35.52a2.317,2.317,0,1,1,1.288,4.149C38.144,39.669,37.143,36.665,38.859,35.52ZM38.716,24.5a3.94,3.94,0,0,1,5.436,3.29,4.054,4.054,0,0,1-3.576,4.149,3.9,3.9,0,0,1-1.86-7.439Zm.715-7.868a2.321,2.321,0,1,1-1,3.576A2.392,2.392,0,0,1,39.432,16.637Zm13.59,5.293c-1.717,4.149-.858,8.726-1.144,13.018a37.809,37.809,0,0,0,8.3-5.865,28.942,28.942,0,0,0,8.583-18.025A17.282,17.282,0,0,0,53.022,21.93ZM11.965,11.2a29.6,29.6,0,0,0,5.579,14.878c2.861,4.006,7.01,6.724,11.158,9.013V27.938a16.245,16.245,0,0,0-4.721-11.445A16.383,16.383,0,0,0,11.965,11.2Z",
    transform: "translate(498.902 348.319)",
    fill: "#f26149",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(295.432 210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 47.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M398.085,653.428v33.365a42.8,42.8,0,0,0,42.8,42.8h0a42.8,42.8,0,0,0,42.8-42.8V653.428Z",
    transform: "translate(-397.605 -652.948)",
    fill: "#ccf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M439.164,728.353a43.333,43.333,0,0,1-43.284-43.284V651.7a.48.48,0,0,1,.48-.48h85.607a.48.48,0,0,1,.48.48v33.365A43.333,43.333,0,0,1,439.164,728.353Zm-42.323-76.168v32.885a42.323,42.323,0,0,0,84.647,0V652.184Z",
    transform: "translate(-395.88 -651.224)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M494.185,474.226a.48.48,0,0,1-.48-.48,37.608,37.608,0,0,0-75.216,0,.48.48,0,0,1-.961,0,38.569,38.569,0,1,1,77.137,0A.48.48,0,0,1,494.185,474.226Z",
    transform: "translate(-412.813 -435.177)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M528.552,755.153,511.19,739.368l5.364-6.611,11.008,8.8,17.273-25.071,7.028,4.837Z",
    transform: "translate(-486.074 -655.21)",
    fill: "#f26149"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "hy_300x47_1_",
    "data-name": "hy_300x47 (1)",
    width: 179,
    height: 28,
    transform: "translate(25 23)",
    fill: "url(#pattern)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRegistrationDesktop);
export default __webpack_public_path__ + "static/media/phone-registration-desktop.73bc3391e99594b709e755d8c7d2f36a.svg";
export { ForwardRef as ReactComponent };